import { render, staticRenderFns } from "./ProfessionInstructionsEdit.vue?vue&type=template&id=5df8c2e8&"
import script from "./ProfessionInstructionsEdit.vue?vue&type=script&lang=js&"
export * from "./ProfessionInstructionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports